import { Theme } from '@mui/material'
import { windowSizes } from '../state/windowState/windowSignals'
// some theme config that depends on state
export const themeOverride = () => {
    return {
        components: {
            MuiDrawer: {
                styleOverrides: {
                    paper: {
                        paddingBottom:
                            (windowSizes.value.insets?.insets.bottom ?? 0) +
                            'px',
                    },
                },
            },
            MuiBackdrop: {
                styleOverrides: {
                    root: {
                        paddingBottom:
                            (windowSizes.value.insets?.insets.bottom ?? 0) +
                            'px',
                    },
                },
            },
            MuiSnackbar: {
                styleOverrides: {
                    root: {
                        paddingTop:
                            (windowSizes.value.insets?.insets.top ?? 0) + 'px',
                    },
                },
            },
        },
    } as Theme
}
